// router.js
import Vue from "vue";
import Router from "vue-router";
// 引入需要的组件
import HomePage from "../page/Home.vue";
import GaiYao from "../page/GaiYao.vue";
import JieShao from "../page/JieShao.vue";
import ShiJi from "../page/ShiJi.vue";
import WenXun from "../page/WenXun.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "HomePage",
      component: HomePage,
    },
    {
      path: "/GaiYao",
      name: "GaiYao",
      component: GaiYao,
    },
    {
      path: "/JieShao",
      name: "JieShao",
      component: JieShao,
    },
    {
      path: "/ShiJi",
      name: "ShiJi",
      component: ShiJi,
    },
    {
      path: "/WenXun",
      name: "WenXun",
      component: WenXun,
    },
    // 可以继续添加更多的路由
  ],
});
